import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Avatar } from 'primeng/avatar';
import { ButtonDirective } from 'primeng/button';
import { CapitalizeFirstPipe } from '@brighthub/helpers';
import { OktaUserInfo } from '@brightside/core/auth';
import { Tooltip } from 'primeng/tooltip';
import { EmployeeSearchService } from '../employee-search.service';
import { Router } from '@angular/router';

@Component({
  selector: 'lib-employee-info',
  imports: [
    CommonModule,
    Avatar,
    ButtonDirective,
    CapitalizeFirstPipe,
    Tooltip,
  ],
  templateUrl: './employee-info.component.html',
  styleUrl: './employee-info.component.scss',
})
export class EmployeeInfoComponent {
  @Input() employeeInfo!: OktaUserInfo;
  @Input() collapsed = false;
  @Input() selected = false;
  @Input() highlight: boolean | undefined = false;

  employeeSearchService = inject(EmployeeSearchService);
  router = inject(Router);

  get initials(): string {
    const { firstName, lastName } = this.employeeInfo;
    return `${firstName[0] ?? ''}${lastName[0] ?? ''}`.toUpperCase();
  }

  selectEmployee(): void {

    this.employeeSearchService.selectEmployee(this.employeeInfo);
    this.router.navigate(['/brightai/employee']);
  }
}
